// eslint-disable-next-line import/no-webpack-loader-syntax
require('./lib/bootstrap.loader?extractStyles!./no-op.js');



//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-loader/extractStyles.js
// module id = 645
// module chunks = 0 1